import { create } from "zustand";
import { persist } from "zustand/middleware";

interface PlaygroundUIState {
  selectedCompanyId: string | null;
  selectedAudioInput: string;
  audioInputDevices: MediaDeviceInfo[];
  devicesLoadedAt: number | null;
  workletsLoaded: boolean;
  setSelectedCompanyId: (id: string | null) => void;
  setSelectedAudioInput: (id: string) => void;
  setAudioInputDevices: (devices: MediaDeviceInfo[]) => void;
  setWorkletsLoaded: (loaded: boolean) => void;
}

export const usePlaygroundStore = create<PlaygroundUIState>()(
  persist(
    (set) => ({
      selectedCompanyId: null,
      selectedAudioInput: "",
      audioInputDevices: [],
      devicesLoadedAt: null,
      workletsLoaded: false,
      setSelectedCompanyId: (id) => set({ selectedCompanyId: id }),
      setSelectedAudioInput: (id) => set({ selectedAudioInput: id }),
      setAudioInputDevices: (devices) =>
        set({ audioInputDevices: devices, devicesLoadedAt: Date.now() }),
      setWorkletsLoaded: (loaded) => set({ workletsLoaded: loaded }),
    }),
    {
      name: "playground-ui",
      partialize: (state) => ({
        selectedCompanyId: state.selectedCompanyId,
        selectedAudioInput: state.selectedAudioInput,
        audioInputDevices: state.audioInputDevices,
        devicesLoadedAt: state.devicesLoadedAt,
        workletsLoaded: state.workletsLoaded,
      }),
    }
  )
);
